import React, { useEffect, useState } from 'react';

import Modal from '../components/Shell/Modal';
import { TemplateField } from '../components/Attributes/Attributes_old';
import Button from '../components/Button';

import useRequired from '../hooks/useRequired';
import useModal from '../hooks/useModal';
import useAsync from '../hooks/useAsync';

import { createPowerUser } from '../api/power-users';

const MODAL_NAME = 'addPowerUser';

const QuickAddPowerUsers = () => {
	const [form, setForm] = useState({});

	const { open: options, setClose } = useModal(MODAL_NAME);

	const { execute: onCreatePowerUser, status: creatingPowerUser } = useAsync(
		createPowerUser,
		{
			immediate: false,
			showNotification: { success: 'Power user added', error: 'raw' },
		}
	);

	useEffect(() => {
		if (options) {
			setForm({
				moduleId: options?.moduleId || null,
			});
		} else {
			setForm({});
		}
	}, [options]);

	return (
		<Modal title="Add power user" open={!!options} onClose={() => setClose()}>
			<div className="grid grid-cols-2 gap-y-4 gap-x-4 text-left">
				<TemplateField
					name="Email"
					span={'sm:col-span-2'}
					dataIndex="email"
					onChange={(index, category) =>
						setForm({ ...form, [index]: category })
					}
				/>
				<TemplateField
					name="First Name"
					optional
					span={'sm:col-span-1'}
					dataIndex="firstName"
					onChange={(index, category) =>
						setForm({ ...form, [index]: category })
					}
				/>
				<TemplateField
					name="Last Name"
					optional
					span={'sm:col-span-1'}
					dataIndex="lastName"
					onChange={(index, category) =>
						setForm({ ...form, [index]: category })
					}
				/>
			</div>
			<div className="flex justify-end mt-6">
				<Button
					onClick={() => {
						onCreatePowerUser(
							{
								...form,
								...(options?.assetId ? { assetId: options?.assetId } : {}),
							},
							(response) => {
								if (typeof options?.onSubmit === 'function') {
									options?.onSubmit({
										label: response.name,
										value: response.id,
										type: 'powermember',
										response,
									});
									setForm({});
								}
								setClose();
							}
						);
					}}
					disabled={!useRequired(form, ['email'])}
				>
					{creatingPowerUser === 'pending'
						? 'Adding Power User'
						: 'Add Power User'}
				</Button>
			</div>
		</Modal>
	);
};

export default QuickAddPowerUsers;
